import React, { useEffect, useState } from 'react';
import { Fancybox } from '@fancyapps/ui'; // its in use please dont remove
import { Button, Col, Collapse, Form, Input, message, Result, Row, Skeleton, Tag, Tooltip, Upload } from 'antd';
import { API_FETCH, URLValidator, validatePlatformShareURL } from '../../../../utils';
import { AiOutlineUpload } from 'react-icons/ai';
import { BsCheckCircle, BsExclamationCircle, BsXCircle, BsInfoCircle } from 'react-icons/bs';
import { useGlobalState } from '../../../../store/state';
// import {SubmitCampaignCreatives} from '../../../../apis/Influencer/Campaigns/SubmitCampaignCreatives'
import './CampaignCreativeCollectionForm.styles.scss';
import { GetSubmittedCreatives } from '../../../../apis/Influencer/Campaigns/GetSubmittedCreatives';
import { Link } from 'react-router-dom';
import { SubmitLivePostURL } from '../../../../apis/Influencer/Campaigns/SubmitLivePostURL';
import { ReSubmitCampaignCreatives } from '../../../../apis/Influencer/Campaigns/ReSubmitCampaignCreatives';

const { Panel } = Collapse;
const { Item, useForm } = Form;
const { Dragger, LIST_IGNORE } = Upload;
const { TextArea } = Input;
const CampaignCreativeReviewCollectionForm = ({ campId, campStatus, getCampaignDetails, platform }) => {
  const [user] = useGlobalState('user');
  const [reviewForm] = useForm();
  const [loading, setLoading] = useState(true);
  const [postLogs, setPostLogs] = useState({
    rejected: [],
    accepted: [],
    review: [],
  });
  const [creativeList, setCreativeList] = useState([]);
  const uploadProps = {
    name: 'filename',
    listType: 'picture',
    FileList: 'fileList',
    accept: 'image/png, image/jpg, image/jpeg, application/pdf, video/mp4, application/msword',
    multiple: false,
    beforeUpload: (info) =>{
      if (
        info.type === 'image/png' ||
                info.type === 'image/jpg' ||
                info.type === 'image/jpeg'||
                info.type === 'video/mp4'||
                info.type === 'application/pdf' ||
                info.type === 'application/msword'
      ) {
        // message.info(`${info.name} file ready to upload!`);
        return info;
      } else {
        message.error(`${info.name} is not a supported file type`);
        return LIST_IGNORE;
      }
    },
    customRequest: function (componentsData) {
      // console.log("inputdata",componentsData)
      const formData = new FormData();
      const _reqHeader = new Headers();
      _reqHeader.append('Authorization', `Bearer ${user.accessToken}`);
      formData.append('creative', componentsData.file);
      fetch(API_FETCH(`/influencer/campaign/${campId}/creatives/image`), {
        method: 'POST',
        headers: _reqHeader,
        body: formData,
        redirect: 'follow',
      })
        .then((response) => response.json())
        .then((result) => componentsData.onSuccess(result));
    },
  };
  const normFile = (e) =>{
    if (e.fileList.length > 1) {
      return [e.fileList[1]];
    } else {
      return e && e.fileList;
    }
  };

  const creativesSubmission = (values) => {
    console.log('values', values);
    // console.log("submission data",values)

    // @note: base model
    const _collectAllCreatives = [];
    for (let i = 0; i < creativeList.length; i++) {
      _collectAllCreatives.push({
        creativeid: values[`creativeid_`+i],
        creativedata: [],
      });
      for (let k = 0; k < creativeList[i].creativedata.length; k++) {
        _collectAllCreatives[i].creativedata.push({
          _id: values[`postId_${i}_${k}`] || undefined,
          title: values[`title_${i}_${k}`] || undefined,
          content: values[`content_${i}_${k}`] || undefined,
          asset: values[`asset_${i}_${k}`] !== undefined ? values[`asset_${i}_${k}`][0].response.response : undefined,
        });
      }
    }

    // pick only object having value from _collectAllCreatives
    const creatives = [];
    _collectAllCreatives.map(({ creativedata, creativeid })=>{
      const _v = {
        creativedata: [],
      };
      creativedata.map((_obj) =>{
        if (Object.values(_obj).includes(undefined) === false) {
          _v.creativedata.push(_obj);
        }
      });
      if (_v.creativedata.length) {
        _v.creativeid = creativeid;
        creatives.push(_v);
      }
    });

    console.log('creatives', creatives);

    // @note hitting resubmit API
    ReSubmitCampaignCreatives(user.accessToken, campId, { creatives: creatives }).then(({ status, response })=>{
      console.log('API: after resubmit posts', response);
      if (status === 200) {
        message.success('Posts Re-Submitted successfully');
        getCreativesSubmitted();
        getCampaignDetails();
      } else {
        message.error('There is some issue with Post Re-submission');
      }
    });
  };

  const getCreativesSubmitted = () => {
    GetSubmittedCreatives(user.accessToken, campId).then(({ status, response })=>{
      console.log('API: Submitted Creative Data', response);
      if (status === 200) {
        // message.success("Rewview Submitted form ready")
        const _logs = {
          rejected: [],
          accepted: [],
          review: [],
        };
        response.map(({ creativedata })=>{
          creativedata.map(({ status, _id })=>{
            if (status === 'rejected') {
              _logs.rejected.push(_id);
            } else if (status === 'accepted') {
              _logs.accepted.push(_id);
            } else if (status === 'review') {
              _logs.review.push(_id);
            }
          });
        });
        console.log('loghs', _logs);
        setPostLogs(_logs);
        setCreativeList([...response]);
        setLoading(false);
      } else {
        message.error('There some issue while submitting your creative');
      }
    });
  };

  const savePostLink = (fieldName, creativeAssetId, postId) =>{
    if (!reviewForm.isFieldTouched(fieldName)) {
      message.warning('Please provide URL to save');
    } else if (reviewForm.getFieldError(fieldName).length) {
      message.warning('Please provide Valid URL to save');
    } else {
      console.log('camps==> ', campId, ':=--=> ', postId);
      SubmitLivePostURL(user.accessToken, campId, creativeAssetId, postId, { url: reviewForm.getFieldValue(fieldName) }).then(({ status, response })=>{
        console.log('Links Submitted successfully', response);
        if (status === 200) {
          message.success(reviewForm.getFieldValue(fieldName)+' saved Succesfully');
          getCreativesSubmitted(); // refreshing Post Details
        } else {
          message.error('there is some issue while saving your post URL');
        }
      });
    }
  };

  useEffect(()=>{
    getCreativesSubmitted();
  }, []);
  return loading ?(
    <div>
      <Skeleton active
        paragraph={{ rows: 6 }}/>
    </div>
  ):(
    <div>
      {creativeList.length ?(
        <Form
          form={reviewForm}
          layout="vertical"
          name="creativesReviewSubmitForm"
          onFinish={creativesSubmission}
        >
          <Collapse
            className="acc_campaign mb-2 common_collapse"
            showArrow={false}
            defaultActiveKey={[1, 2, 3, 4]}
          >

            {
              creativeList.map(({ format, creativedata, creativeAssetId, asset, status }, index)=>(
                <Panel key={index+1}
                  showArrow={false}
                  header={
                    <h3 >Creative #{index + 1}</h3>
                  }
                >
                  <ul className="cc_preview_each_basics">
                    <li>
                      <p>Status</p>
                      <h6>{status}</h6>
                    </li>
                    <li>
                      <p>No. of posts</p>
                      <h6>{creativedata.length}</h6>
                    </li>
                  </ul>
                  <Item
                    name={`creativeid_`+index}
                    hidden={true}
                    initialValue={creativeAssetId}
                  >
                    <Input type="hidden" />
                  </Item>

                  {
                    creativedata.map(({ asset, content, title, _id, posturl, ...other }, i)=>{
                      if (other.status === 'accepted' || other.status === 'review') {
                        return (
                          <div key={_id}
                            className="creativePosts_each approved text-left">
                            <div className="creativePosts_each_stat">
                              {
                                other.status ==='accepted' ?(
                                  <Tag icon={<BsCheckCircle/>}
                                    color='success'>Accepted</Tag>
                                ):(
                                  <Tag icon={<BsExclamationCircle/>}
                                    color='warning'>In Review</Tag>
                                )
                              }
                            </div>
                            <div className="creativePosts_each_count float-right">
                              <span>{i+1}</span>/{creativedata.length}
                            </div>
                            <Row gutter={12}
                              className="">
                              <Col span={10}>
                                <a className="approved_data_asset"
                                  data-fancybox={_id}
                                  href={asset.url}>
                                  <img src={asset.url}
                                    className="img-fluid"
                                    alt={asset.filename} />
                                </a>
                              </Col>
                              <Col span={14}>
                                <div className="approved_data text-left">
                                  <div className="approved_data--label">Post title</div>
                                  <h6 className="approved_data--title">{title}</h6>
                                </div>
                                <div className="approved_data text-left">
                                  <div className="approved_data--label">Post Description</div>
                                  <h6 className="approved_data--para">{content}</h6>
                                </div>
                                {
                                  posturl !== '' && campStatus === 'active'?
                                    <div className="approved_data text-left">
                                      <div className="approved_data--label">Post Link Provided</div>
                                      <h6 className="approved_data--para">{posturl}</h6>
                                    </div>:
                                    null

                                }
                                {
                                  campStatus === 'active'?(
                                    posturl === '' ? (
                                      <Row className="pt-1">
                                        <Col span={16}>
                                          <Item
                                            name={`linksubmit_${index}_${i}`}
                                            rules={[
                                              { required: true, message: 'This cant be empty' },
                                              { validator: (_, value) =>{
                                                if (value && !validatePlatformShareURL(value, platform)) {
                                                  return Promise.reject(new Error(`This is not a valid ${platform} share URL`));
                                                } else {
                                                  return Promise.resolve();
                                                }
                                              } },
                                            ]}
                                          >
                                            <Input type="text"
                                              className="common_input"
                                              size="large"
                                              placeholder="Post Link"/>
                                          </Item>
                                        </Col>
                                        <Col span={8}>
                                          <Button className="common_button ml-2"
                                            onClick={() =>savePostLink(`linksubmit_${index}_${i}`, creativeAssetId, _id) }>Save Link</Button>
                                        </Col>
                                      </Row>
                                    ):(
                                      <div className="approved_data text-left">
                                        <div className="approved_data--label">Post URL</div>
                                        <a href={posturl || '/influencer'}
                                          className="approved_data--para link"
                                          target="_blank"
                                          rel="noreferrer">{posturl || 'https://flynt.social'}</a>
                                      </div>
                                    )
                                  ):null
                                }
                              </Col>
                            </Row>
                          </div>
                        );
                      } else if (other.status === 'rejected') {
                        return (
                          <div key={_id}
                            className="creativePosts_each reject">
                            <div className="creativePosts_each_stat">
                              <Tooltip
                                title="This post is rejected by admin, Please consider Re-submission"
                              >
                                <BsInfoCircle className="mr-2"/>
                              </Tooltip>
                              <Tag icon={<BsXCircle/>}
                                color="error">Rejected</Tag>
                            </div>
                            <div className="creativePosts_each_count">
                              <span>{i+1}</span>/{creativedata.length}
                            </div>
                            <Row gutter={12}
                              className="text-left">
                              <Col span={24}>
                                {/* <hr /> */}
                                <h5 className="reject_title m-0 pb-2">Reason for Rejections</h5>
                                <p className="m-0"
                                  style={{ whiteSpace: 'pre-line' }}>{other.adminMessage || 'There is no comments by Admin'}</p>
                              </Col>
                              <Col span={24}>
                                <hr />
                                <h5 className="reject_title"
                                  style={{ opacity: 0.7 }}>Old Submission</h5>
                              </Col>
                              <Col span={10}
                                style={{ opacity: 0.7 }}>
                                <a className="approved_data_asset"
                                  data-fancybox={_id}
                                  href={asset.url}>
                                  <img src={asset.url}
                                    className="img-fluid"
                                    alt={asset.filename} />
                                </a>
                              </Col>
                              <Col span={14}
                                style={{ opacity: 0.7 }}>
                                <div className="approved_data text-left">
                                  <div className="approved_data--label">Post title</div>
                                  <h6 className="approved_data--title"
                                    style={{ color: '#333' }}>{title}</h6>
                                </div>
                                <div className="approved_data text-left">
                                  <div className="approved_data--label">Post Description</div>
                                  <h6 className="approved_data--para">{title}</h6>
                                </div>
                              </Col>
                              <Col span={24}>
                                <hr />
                                <h5 className="reject_title">Post Re-Submission</h5>
                              </Col>
                              {/* form Related */}
                              <Col span={14}>
                                <Item
                                  name={`postId_${index}_${i}`}
                                  hidden={true}
                                  initialValue={_id}
                                >
                                  <Input type="hidden" />
                                </Item>
                                <Item
                                  name={`title_${index}_${i}`}
                                  label="Post Title"
                                  rules={[{ required: true, message: 'This can\'t be empty' }]}
                                >
                                  <Input
                                    className="common_input"
                                    type="text"
                                    size="large"
                                    placeholder="Eg: New product lauch do check"/>
                                </Item>
                                <Item
                                  name={`content_${index}_${i}`}
                                  label="Post Description"
                                  rules={[{ required: true, message: 'This can\'t be empty' }]}
                                >
                                  <TextArea
                                    className="common_input"
                                    rows={6}
                                    placeholder="Describe your post with suggested keyowrds, Also use hashtags and mentions..."/>
                                </Item>
                              </Col>
                              <Col span={10}>
                                <Item

                                  name={`asset_${index}_${i}`}
                                  label="Upload Creative"
                                  valuePropName="fileList"
                                  getValueFromEvent={normFile}
                                  rules={[{ required: true, message: 'This can\'t be empty' }]}
                                >
                                  <Dragger style={{ width: '100%' }}
                                    {...uploadProps} >
                                    <p className="text-center svg-icon">
                                      <AiOutlineUpload size={24} />
                                    </p>
                                    <p className="ant-upload-text"><strong>Click or Drag & Drop</strong><br/>your file here to upload</p>
                                    <p className="ant-upload-hint">Supports png/jpg,jpeg,pdf,doc,mp4</p>
                                  </Dragger>
                                </Item>
                              </Col>
                            </Row>
                          </div>
                        );
                      }
                    })
                  }
                </Panel>
              ))
            }

          </Collapse>
          <div className="text-right">
            {
              postLogs.rejected.length ? (
                <Button
                  className="common_button"
                  title="Submit your All creatives"
                  htmlType="submit"
                >Re-Submit Creatives</Button>
              ):null
            }
          </div>
        </Form>
      ): (
        <Result
          title="No creatives submitted for this campaign"
          extra={
            <Link to="/influencer/campaigns/">
              <Button className="common_button">Go to Campaigns</Button>
            </Link>

          }
        />
      )
      }
    </div>
  );
};

export default CampaignCreativeReviewCollectionForm;
